// export const URL = 'http://localhost:5001/linehero-09132020/us-central1/api';
export const URL =
  'https://us-central1-linehero-09132020.cloudfunctions.net/api';

export const websiteURL = 'https://linehero.com/';

